import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';

export const getGlobalFilter = (query: string) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() + `global-filter?where=` + query
  );
};
export const getSystemConfig = (query: string) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() + `system-config?where=` + query
  );
};
export const AddGlobalFilter = (obj: Object) => {
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `global-filter/create`,
    obj
  );
};
export const EditGlobalFilter = (obj: Object) => {
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `global-filter/update`,
    obj
  );
};
export const DeleteGlobalFilter = (obj: Object) => {
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `global-filter/delete`,
    obj
  );
};
